module.exports = __webpack_public_path__ + "img/icon-tracking-upload.9df0ef68.svg";